import Swal from "sweetalert2";
import VoucherIcon from "../../../Components/Svgs/VoucherIcon";
import PageTitle from "../../../Components/UI/PageTitle";
import { useEffect, useState } from "react";
import { clientVoucherRedeem, getVouchersList } from "../../../apis";
import Loader from "../../../Components/Loader";
import { useNavigate } from "react-router-dom";
import CustomPagination from "../../../Components/CustomPagination";
import { copyToClipboard } from "../../../_helper";

const VouchersList = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [vouchers, setVouchers] = useState([]);
  const [clientPointingBalance, setClientPointingBalance] = useState(0);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoading(true);
    getVouchersList(currentPage)
      .then((response) => {
        const { vouchers, clientPointingBalance } = response.data.data;

        setVouchers(vouchers.data);
        setClientPointingBalance(clientPointingBalance);
        setPagination({
          current_page: vouchers.current_page,
          last_page: vouchers.last_page,
        });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClaimVoucher = (voucherCode) => {
    Swal.fire({
      title: "Success",
      html: `
      <p>Voucher has been claimed successfully</p>
      <div class="tw-mt-4 tw-p-2 tw-bg-gray-100 tw-rounded tw-text-center tw-text-lg tw-font-bold">
        ${voucherCode}
      </div>
      <button id="copyVoucherBtn" class="tw-mt-3 tw-px-4 tw-py-2 tw-bg-sky-500 tw-text-white tw-rounded hover:tw-bg-sky-600">
        Copy Code
      </button>
    `,
      icon: "success",
      showConfirmButton: false, // remove default OK button
      didOpen: () => {
        document
          .getElementById("copyVoucherBtn")
          .addEventListener("click", () => {
            copyToClipboard(voucherCode);
            Swal.fire({
              icon: "success",
              title: "Copied!",
              text: "Voucher code has been copied to your clipboard.",
              timer: 1500,
              showConfirmButton: false,
            }).then(() => {
              navigate(0);
            });
          });
      },
    });
  };

  const handleGetVoucher = async (voucherId) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to get this voucher?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, get it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      clientVoucherRedeem(voucherId)
        .then((response) => {
          console.log(response);

          if (response.data.status) {
            handleClaimVoucher(response.data.data.code);
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "Error",
            text: `${error.message}`,
            icon: "error",
          });
        });
    }
  };
  if (isLoading) return <Loader />;
  return (
    <>
      <PageTitle title={"Vouchers List"} />
      <div className="tw-mb-2 tw-text-right tw-text-base">
        Your Points :{" "}
        <span className="tw-font-bold tw-text-primary">
          {clientPointingBalance ?? 0}
        </span>
      </div>
      <div className="tw-p-4 tw-border tw-rounded-lg tw-shadow-lg tw-bg-white">
        {/* Card 1 */}
        {vouchers?.map((v) => (
          <div
            key={v.num}
            href="#"
            className="tw-border-2 tw-border-b-4 tw-mb-2 tw-border-gray-200 !tw-rounded-xl hover:tw-bg-gray-50"
          >
            {/* Badge */}
            <p className="tw-bg-primaryLight tw-w-fit tw-px-4 tw-py-1 tw-text-sm tw-font-bold tw-text-white tw-rounded-tl-lg tw-rounded-br-xl">
              {v.isActive ? "Available" : "Not Available"}
            </p>
            <div className="tw-flex tw-p-3 tw-gap-y-2">
              <div className="tw-me-6">
                <VoucherIcon />
              </div>
              {/* Description */}
              <div className="tw-col-span-5 md:tw-col-span-4 tw-ml-4">
                <p className="tw-text-primary tw-font-bold tw-text-lg">
                  {v.name}
                </p>
                <p className="tw-text-gray-600 tw-font-bold">
                  {v.points} Points
                </p>
                <p className="tw-text-gray-400">
                  Valid on {v.numOfPackages} packages
                </p>
              </div>
              {/* Price */}
              <div className="tw-flex tw-col-start-2 w-col-start-auto !tw-justify-end tw-ml-auto">
                {v.isRedeemed ? (
                  <p className="tw-rounded-lg tw-text-white tw-font-bold tw-bg-gray-400 tw-py-1 tw-px-3 tw-text-sm tw-w-fit tw-h-fit ">
                    Redeemed
                  </p>
                ) : v.canRedeem ? (
                  <button
                    onClick={() => handleGetVoucher(v.id)}
                    className="!tw-rounded-lg tw-text-white tw-font-bold tw-bg-primary tw-py-1 tw-px-3 tw-text-sm tw-w-fit tw-h-fit hover:tw-shadow-xl hover:tw-bg-primaryLight tw-cursor-pointer"
                  >
                    Redeem
                  </button>
                ) : (
                  <p className="tw-rounded-lg tw-text-white tw-font-bold tw-bg-gray-400 tw-py-1 tw-px-3 tw-text-sm tw-w-fit tw-h-fit ">
                    Insufficient Points
                  </p>
                )}
              </div>
            </div>
          </div>
        ))}

        <div className="flex justify-center mt-4">
          <CustomPagination
            totalPages={pagination?.last_page}
            currentPage={pagination?.current_page || 1}
            onPageChange={handlePageChange}
          />
        </div>
      </div>
    </>
  );
};

export default VouchersList;
